<template>
  <div
    v-if="isShowPage"
    class="login"
  >
    <guide class="guide" />
    <nav-bar
      :title="lang.loginLang"
      class="nav-bars"
      :show-type="'text'"
    />
    <!-- <button @click="test">测试</button> -->
    <div class="login_wap login_pc">
      <!-- pc端logo显示 -->
      <p class="login_pc_title">
        <img
          src="../../assets/logo.png"
          alt=""
        >
      </p>
      <!-- wap端logo显示 -->
      <img
        src="//uatstatic.house730.com.cn/m/images/icon.png"
        alt=""
        class="login_wap_img"
      >
      <!-- tab切换 -->
      <van-tabs
        v-model="tabLogin"
        title-active-color="#ed1c24"
        :line-width="110"
        title-inactive-color="#333"
        @click="cutoverTab"
      >
        <!-- 快捷登入 -->
        <van-tab :title="lang.fastLoginLang">
          <house-form
            ref="forms"
            :type="'login'"
            :active="1"
            :model="model"
            class="login_pc_form login_wap_form"
            :error="error"
            :is-pc="isPc"
            :number="number"
          >
            <!-- <div class="cf-turnstile" data-sitekey="0x4AAAAAAA5cvFWzROd-Zom4" data-callback="onTurnstileCallback"></div> -->
            <!-- <div class="cf-turnstile" data-sitekey="0x4AAAAAAA5cvFWzROd-Zom4"></div> -->
            <house-form-item class="login_pc_form_item login_wap_form_item">
              <!-- 待开放 -->
              <house-select
                v-model="model.check"
                :options="options"
                placeholder="852"
              />
              <house-input
                v-model.trim="model.telephone"
                :no-past="true"
                type="text"
                :placeholder="lang.telPointLang"
                :del-btn="model.telephone"
                @del="delModel('telephone')"
              />
            </house-form-item>
            <house-form-item class="login_pc_form_item login_wap_form_item">
              <house-input
                v-model.trim="verifyCode"
                type="text"
                :placeholder="lang.ImgPointLang"
                maxlength="4"
                @keyupEnter="loginBtn"
              />
              <img
                :src="verifyImg"
                alt=""
                class="verifyImg"
                @click="loadImg"
              >
            </house-form-item>
            <house-form-item class="login_pc_form_item login_wap_form_item">
              <house-input
                v-model.trim="model.code"
                :no-past="true"
                type="text"
                :placeholder="lang.SMSPointLang"
                @keyupEnter="fastLogin"
              />
              <houseCode
                :error="error"
                :user-input="model"
                :verify-code="verifyCode"
                :verify-token="verifyToken"
                @end="endBackword"
                @click="sendCode"
                @refresh-captcha="loadImg"
              />
            </house-form-item>
            <house-form-item class="login_pc_form_item login_wap_form_item">
              <!-- 新闻接收邮箱 存在禁止修改 -->
              <house-input
                v-model.trim="model.subscribeEmail"
                :no-past="true"
                :edit-disable="editDisable"
                type="text"
                :placeholder="lang.newsPointLang"
                :del-btn="model.subscribeEmail"
                @del="delModel('subscribeEmail')"
              />
            </house-form-item>

            <div class="login_wap_agree">
              <house-agree
                v-model="model.agree"
              >
                <span class="agree_info">{{ lang.agreeLang }}</span> <a :href="lang.tremsUrl">{{ lang.house730Lang }}</a>
              </house-agree>
            </div>
            <div
              v-if="subscribeTo"
              class="conCheckboxList"
            >
              <house-agree v-model="model.subscribeEmailStatus">
                <div
                  class="sub_tit"
                  @click="changeSubStatus"
                >
                  {{ lang.subtit }}
                </div>
              </house-agree>
              <div
                v-show="!model.subscribeEmail && haveRegister && model.telephone"
                class="red_txt"
              >
                {{ lang.emailTit }}
              </div>
            </div>
          </house-form>
          <!-- <div>{{ number }}-{{ errorBox }}-{{ error }}</div> -->
          <div
            class="red_btn"
            :class="[fastLightBtn ? 'red_active' : '', thirtyError && !isPc && error ? 'red_bottom' :'', number == 1312 && error && errorBox && !isPc ? 'red_btn_111': '', number != 1312 && error ? 'red_btn_30': '']"
            @click="fastLogin"
          >
            {{ lang.loginLang }}
          </div>
        </van-tab>
        <!-- 賬號密碼登入 -->
        <van-tab :title="lang.userLoginLang">
          <!-- 切换登入方式 -->
          <div
            class="cut_pc_btn"
            @click="checkPcLogin"
          >
            {{ loginType == 'email' ? lang.telLang : lang.emailLang }}
          </div>
          <house-form
            ref="form"
            :type="'login'"
            :active="2"
            :model="loginList"
            class="login_pc_form login_wap_form"
            :error="error"
            :is-pc="isPc"
            :number="number"
          >
            <house-form-item
              v-show="loginType == 'email'"
              class="login_pc_form_item login_wap_form_item"
            >
              <house-input
                v-model.trim="loginList.email"
                :placeholder="lang.emailPointLang"
                :del-btn="loginList.email"
                @del="delLoginList('email')"
                @blur="hasPassword('Email')"
              />
              <span
                class="blue_btn cut_btn"
                @click="checkLogin('tel')"
              >{{ lang.telLang }}</span>
            </house-form-item>
            <house-form-item
              v-show="loginType == 'tel'"
              class="login_pc_form_item login_wap_form_item"
            >
              <house-select
                v-model="loginList.check"
                :options="options"
                placeholder="852"
              />
              <house-input
                v-model.trim="loginList.telephone"
                type="text"
                :placeholder="lang.telPointLang"
                :del-btn="loginList.telephone"
                @del="delLoginList('telephone')"
                @blur="hasPassword('Phone')"
              />
              <span
                class="blue_btn cut_btn"
                @click="checkLogin('email')"
              >{{ lang.emailLang }}</span>
            </house-form-item>
            <!-- end -->
            <house-form-item class="login_pc_form_item login_wap_form_item">
              <house-input
                v-model.trim="loginList.password"
                :type="eyeType"
                :placeholder="lang.passwordPointLang"
                @keyupEnter="loginBtn"
              />
              <svg
                class="icon icon_eye"
                aria-hidden="true"
                @click="eyeOpen"
              >
                <use :xlink:href="eyeSvg" />
              </svg>
            </house-form-item>
            <house-form-item
              v-show="imgValidatorOpen"
              class="login_pc_form_item login_wap_form_item"
            >
              <house-input
                v-model.trim="verifyCode"
                type="text"
                :placeholder="lang.ImgPointLang"
                maxlength="4"
                @keyupEnter="loginBtn"
              />
              <img
                :src="verifyImg"
                alt=""
                class="verifyImg"
                @click="loadImg"
              >
            </house-form-item>
            <div class="login_pc_remember">
              <!-- <house-agree v-model="loginList.remember">記住密碼</house-agree> -->
              <span @click="goForget">{{ lang.forgetPasswordLang }}</span>
            </div>
          </house-form>
          <div
            class="red_btn"
            :class="[lightBtn ? 'red_active' : '', thirtyError && !isPc && error? 'red_bottom' :'',number == 1312 && error && errorBox && !isPc ? 'red_btn_111': '', number != 1312 && error ? 'red_btn_30': '']"
            @click="loginBtn"
          >
            {{ lang.loginLang }}
          </div>
          <div class="login_pc_forget">
            <!-- <p class="school_btn" @click="goSchool">{{ lang.schoolLang }}</p> -->
          </div>
          <div class="login_wap_forget_case">
            <div class="login_wap_forget">
              <div
                class="write_btn"
                @click="goForget"
              >
                {{ lang.forgetPasswordLang }}
              </div>
              <!-- <p class="school_btn" @click="goSchool">{{ lang.schoolLang }}</p> -->
            </div>
          </div>
        </van-tab>
        <div 
          v-if="showGoogle || showFacebook || showApple"
          class="tab-content" 
        >
          <span class="line" />
          <span>{{ lang.or }}</span>
          <span class="line" />
        </div>
        <template v-if="showGoogle">
          <div 
            v-if="isPcLogin" 
            key="google-pc-box" 
            style="margin-top: 10px; width: 100%; box-sizing: border-box;"
          >
            <div 
              ref="googleSignIn" 
              class="g_id_signin" 
            />
          </div>
          <div 
            v-else 
            key="google-h5-box" 
            class="googlebox"
          >
            <div 
              class="custom-google-wrapper" 
              @click="loginWithRedirect('google')"
            >
              <div class="design-btn">
                <img 
                  alt="Google" 
                  src="../../assets/Google.png" 
                >
              </div>
            </div>
          </div>
        </template>

        <template v-if="showFacebook">
          <div 
            v-if="isPcLogin" 
            key="facebook-pc-box"
            class="third-party-buttons" 
          >
            <div
              class="social-btn facebook-redirect-btn"
              @click="handleFacebookClick"
            >
              <img 
                src="../../assets/Facebook.png" 
                alt="Facebook" 
                class="social-icon" 
              >
              <span class="social-text">

                {{ lang.facebooklogin }}
              </span>
            </div>
          </div>
          <div 
            v-else 
            key="facebook-h5-box"
            class="facebookbox"
          >
            <div
              class="custom-facebook-wrapper"
              @click="handleFacebookLogin"
            >
              <div class="design-btn">
                <img
                  src="../../assets/Facebook.png"
                  alt="Facebook"
                >
              </div>
            </div>
          </div>
        </template>

        <template v-if="showApple">
          <div 
            v-if="isPcLogin" 
            key="apple-pc-box"
            class="third-party-buttons" 
          >
            <div
              class="social-btn apple-redirect-btn"
              @click="handleAppleSignIn"
            >
              <img 
                src="../../assets/apple.png" 
                alt="Apple" 
                class="social-icon" 
              >
              <span class="social-text">
                {{ lang.applelogin }}
              </span>
            </div>
          </div>
          <div 
            v-else 
            key="apple-h5-box"
            class="applebox"
          >
            <div
              class="custom-apple-wrapper"
              @click="handleAppleSignIn"
            >
              <div class="design-btn">
                <img
                  src="../../assets/apple.png"
                  alt="Apple"
                >
              </div>
            </div>
          </div>
        </template>
      </van-tabs>
    </div>
    <van-dialog 
      v-model="isThirdPartyLogging" 
      :show-confirm-button="false" 
      class="login_case"
    >
      <div class="login_content">
        <div>
          <van-loading 
            class="loading" 
            color="#1989fa" 
            size="20px" 
            vertical 
          />
        </div>
        <div>
          登录中
        </div>
      </div>
    </van-dialog>
    <!-- agree弹出层 -->
    <van-dialog
      v-model="agreeShow"
      class="agree_case"
      :confirm-button-text="lang.continueLang"
    >
      <div class="agree_content">
        {{ lang.agreeNoticeLang }}
      </div>
    </van-dialog>
  </div>
</template>
<script>
import houseForm from '../../components/houseLogin/houseForm';
import houseFormItem from '../../components/houseLogin/houseFormItem.vue';
import houseInput from '../../components/houseLogin/houseInput.vue';
import houseSelect from '../../components/houseLogin/houseSelect.vue';
import houseCode from '../../components/houseLogin/houseCode.vue';
import houseAgree from '../../components/houseLogin/houseAgree.vue';
import guide from '../../components/guide';
import navBar from '../../components/navBar';
import pub from '../../../common/public';
import lang from '../../../common/language/new_login';
import { posthogPayloadsMethod } from '../../../common/js/posthog';
const _conf = require('../../../common/js/_conf');
const FACEBOOK_API_VERSION = 'v20.0';
export default {
  components: {
    houseForm,
    houseFormItem,
    houseInput,
    houseSelect,
    houseCode,
    houseAgree,
    guide,
    navBar,
  },
  data() {
    return {
      showGoogle: false,
      showFacebook: false,
      showApple: false,
      appleClientId: '',
      isAppleInitialized: false,
      isThirdPartyLogging:false,
      googleClientId: '',
      facebookAppId: '',
      FACEBOOK_API_VERSION:'v20.0',
      // isConfigLoaded:false,
      isGoogleInitialized: false,
      deviceCode: 'WEB',
      haveRegister:false,
      errorBox: false,
      thirtyError:false,
      helpConfig:'',
      subscribeTo: true,
      isShowPage: true,
      agreeShow: false,
      backUrl: '/',
      lang: lang,
      //同意条款
      // model: {
      //   telephone: '',
      //   code: '',
      //   check: '852',
      //   agree: '',
      // },
      model: {
        telephone: '',
        code: '',
        check: '852',
        agree: '',
        subscribeEmail: '',
        subscribeEmailStatus: true,
      },
      editDisable: false,
      //登入数据
      loginList: {
        telephone: '',
        code: '',
        password: '',
        check: '852',
        email: '',
      },
      error: '', //报错信息
      switchCode: true, //验证码开关
      lightCode: false, //动态检验
      loginType: 'tel', //切换登入方式
      eyeType: 'password', //密码显示隐藏
      eyeSvg: '#icon-yincangmima', //密码icon
      imgValidatorOpen: false, //图片验证
      isfirstlogin: false,
      tabLogin: 0, //切换登入類型,
      verifyImg: '', //验证图形
      verifyCode: '', //图形验证码
      verifyToken: '', //图形验证token
      options: [
        { name: '853', id: '1' },
        { name: '852', id: '2' },
        { name: '86', id: '3' },
      ],
      isPc: false,
      isPcLogin:false,
      resizeTimer: null,
      number: null,
      // turnstileVerified: false,
      // turnstileToken: '',
    };
  },
  computed: {
    /* 账号密码登入按钮高亮 */
    lightBtn() {
      let { telephone, email, password } = this.loginList;
      return (telephone.length > 0 || email.length > 0) && password.length > 0 ? true : false;
    },
    /* 快捷登入按钮高亮 */
    fastLightBtn() {
      let { telephone, code, subscribeEmail } = this.model;
      if (telephone.length > 0 && code.length > 0 && subscribeEmail.length > 0) {
        return true;
      }
        return false;

      // let { telephone, code } = this.model;
      // if (telephone.length > 0 && code.length > 0) {
      //   return true;
      // } else {
      //   return false;
      // }
    },
    modelTel() {
      return this.model.telephone;
    },
    modelEmail() {
      return this.model.subscribeEmail;
    },
    loginListTel() {
      return this.loginList.telephone;
    },
    loginListEmail() {
      return this.loginList.email;
    },
  },
  watch: {
    isPcLogin(newVal) {
      if (!newVal) {
        // 1. 切换到移动端时：清理垃圾
        console.log(" 切换至移动端，清扫 Google 残留");
        this.cleanupGoogleElements();
      } else {
        // 2. 切换回 PC 端时：等待 DOM 渲染完毕，手动重新绘制 Google 按钮
        console.log("切换回 PC 端，正在重新渲染 Google 按钮...");
        this.$nextTick(() => {
          this.renderGoogleButton();
        });
      }
    },
    'model.telephone': {
      handler() {
        let result = pub.telValidator(this.modelTel);
        if (this.modelTel && result == 2) {
          this.error = this.lang.errTelFormLang;
          this.haveRegister = false
        } else {
          this.error = '';
          this.number = null;
          this.hasSubEmail('Email');
          this.subscribeTo = true;
        }
        this.errorBox = true
      },
      deep: true,
    },
    'loginList.telephone': {
      handler() {
        let result = pub.telValidator(this.modelTel);
        if (this.modelTel && result == 2) {
          this.error = this.lang.errTelFormLang;
        } else {
          this.error = '';
          this.number = null;
        }
        this.errorBox = true
      },
      deep: true,
    },

    'model.subscribeEmail': {
      handler() {
        let resultEmail = pub.emailValidator(this.modelEmail);
        if (this.modelEmail && resultEmail != 0) {
          this.error = this.lang.errEmailFormLang;
          this.errorBox = true
        } else {
          this.error = '';
          this.bumber = null;
        }
      },
      deep: true,
    },
    // model: {
    //   handler() {
    //     let result = pub.telValidator(this.modelTel);
    //     let resultEmail = pub.emailValidator(this.modelEmail);
    //     if (this.modelTel && result == 2) {
    //       this.error = this.lang.errTelFormLang;
    //     } else {
    //       this.error = '';
    //     }
    //     if (this.modelEmail && resultEmail != 0) {
    //       this.error = this.lang.errEmailFormLang;
    //     } else {
    //       this.error = '';
    //     }
    //   },
    //   deep: true,
    // },
    loginList: {
      handler() {
        let resultTel = pub.telValidator(this.loginListTel);
        let resultEmail = pub.emailValidator(this.loginListEmail);
        if (this.loginListTel && resultTel != 0 && this.loginType == 'tel') {
          switch (resultTel) {
            case 1:
              this.error = this.lang.errTelLang;
              break;
            case 2:
              this.error = this.lang.errTelFormLang;
              break;
            default:
              break;
          }
        } else if (this.loginListEmail && resultEmail != 0 && this.loginType == 'email') {
          this.error = this.lang.errEmailFormLang;
        } else {
          this.error = '';
        }
      },
      deep: true,
    },
    verifyCode(value) {
      let reg = /^\d{4}$/;
      if (reg.test(value)) {this.error = '';}
    },
  },
  created() {
  console.log('发布的环境是：', _conf.env_type == 4 ?'https://simm.house730.com sim环境':'https://uatm.house730.com.cn uat环境');
    this.helpConfig = _conf.env_type == 3 ?'https://m.house730.com': _conf.env_type == 4?'https://simm.house730.com':'https://uatm.house730.com.cn'
    this.isPc = !(document.body.clientWidth <= 600 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    this.$route.query && this.$route.query.referrer ? (this.backUrl = this.$route.query.referrer) : (this.backUrl = '/');
    this.$route.query && this.$route.query.tab == 1 ? (this.tabLogin = 1) : (this.tabLogin = 0);
    this.getConfig()


//     document.addEventListener("DOMContentLoaded", () => {
// console.log("ccccc")
// window.cfcb = function(token) {
//     console.log('Execute callback, got token: ')
//     console.log(token)
// }
// })

    // window.onloadTurnstileCallback = () => {
    //     turnstile.render('.cf-turnstile', {
    //       sitekey: "0x4AAAAAAA5cvFWzROd-Zom4",
    //       callback: (token) => {
    //         console.log(`Challenge Success ${token}`);
    //         this.turnstileVerified = true;
    //         this.turnstileToken = token;
    //       },
    //       'error-callback': () => {
    //         console.log('Challenge Failed');
    //         this.turnstileVerified = false;
    //       }
    //     });
    // };
  },
  async mounted () {
    // 1. 初始化时先执行一次检测
    this.checkDevice();
    // 2. 监听窗口大小变化（当你在控制台切换手机端模拟器，或者拖拽窗口时会实时触发）
    window.addEventListener('resize', this.checkDevice);

    // 重定向回调token解析
    this.checkGoogleRedirectCallback();
    this.checkFacebookRedirectCallback();
    this.checkAppleRedirectCallback();
    // 动态获取client id
    await this.fetchOauthConfig('AppleClientId');
    await this.fetchOauthConfig('GoogleClientId');
    await this.fetchOauthConfig('FacebookClientId');
    this.loadImg()
    
    let payloads = await posthogPayloadsMethod()
    dataLayer.unshift({
      event: 'pageview',
      source: 'LIP',
      target: '',
      user: {
        language: `${window._language}`, // ie 'zh-hk'
        id: '', // ie '41121'
      },
      posthog: { payloads: payloads },
    });
    // console.log('dataLayer', window.dataLayer);
//     console.log("window.turnstile", window.turnstile)

//     if (window.turnstile) {
//       console.log("window.turnstileqaaaaaa")
//       const token = window.turnstile.getResponse();
//       console.log("token", token)
//         if (token) {
//           console.log("这是token", token)

//         }
//     }
// // 确保 Turnstile 脚本加载完成
// if (window.turnstile) {
//       window.turnstile.render('.cf-turnstile', {
//         sitekey: '0x4AAAAAAA5cvFWzROd-Zom4',
//         callback: 'onTurnstileCallback'
//       });
//     } else {
//       console.error('Turnstile script not loaded.');
//     }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    async getConfig(){
      try {
        const res = await this.axios.get(this.pub.getApi().GetWapConfig + '?key=ThirdRegistration');
        const resultStr = res.data.result || ''; 
        // 使用 includes 进行简单判断
        this.showGoogle = resultStr.includes('Google');
        this.showFacebook = resultStr.includes('Facebook');
        this.showApple = resultStr.includes('Apple');
        // Apple Sign In SDK 初始化
        // if (this.showApple) {
        //   this.initAppleSdk();
        // }
      } catch (error) {
        console.error('获取配置失败:', error);
      }
    },
    checkDevice() {
      this.isPcLogin = !(document.body.clientWidth <= 600 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
      console.log("resize",this.isPcLogin)
    },
    async fetchOauthConfig(id) {
      //  设置一个状态锁，用来标记是否已经成功处理过（无论成功还是超时保底）
      // let isHandled = false;

      // // 开启 2.5 秒超时定时器
      // const timeoutId = setTimeout(() => {
      //   if (!isHandled) {
      //     console.warn(` 接口请求 [${id}] 超过 2.5 秒未响应，触发前端超时保底激活！`);
      //     isHandled = true;
      //     // this.executeFallback(id); // 执行保底
      //   }
      // }, 2500);

      try {
        // 假设这是你的后端接口
        const res = await this.axios.get(this.pub.getApi().GetWapConfig + `?key=${id}`);
        //  3. 如果接口在 2.5 秒内回来了，立刻清除定时器，拦截保底逻辑
        // if (!isHandled) {
        //   isHandled = true;
        //   clearTimeout(timeoutId); // 成功拦截，取消保底
        // } else {
        //   // 如果接口回来得太慢，此时超时保底已经执行过了，直接退出，防止二次重复渲染
        //   return; 
        // }

        if (res && res.data.code === 0 && res.data.result) {
          if (id == 'GoogleClientId') {
            this.googleClientId = res.data.result;
            this.initGoogleOneTap();
            this.renderGoogleButton();
          } else if (id == 'FacebookClientId') {
            this.facebookAppId = res.data.result;
            this.initFacebookSdk();
          }else if(id == 'AppleClientId'){
            this.appleClientId = res.data.result;
            this.initAppleSdk();
          }
          // this.isConfigLoaded = true; // 解锁
        } else {
          // 虽接口成功返回但 code 不对或 result 为空，也直接走保底
          console.error(` 接口返回数据异常 [${id}]，转为保底逻辑`);
          // this.executeFallback(id);
        }
      } catch (error) {
        //  4. 接口报错抓取
        // if (!isHandled) {
        //   isHandled = true;
        //   clearTimeout(timeoutId);
        // }
        console.error(`动态获取三方配置失败 [${id}]:`, error);
        // this.executeFallback(id);
      }
    },
    async handleCredentialResponse(response) {
      const idToken = response.credential; // ✅ 这就是你需要的 id_token

      // 调用你的后端接口
      await this.registerOrLoginWithThirdParty(idToken, 1);
    },
 
    initFacebookSdk() {
      console.log("--- 开始准备加载 Facebook SDK ---");
      // 1. 挂载/重置全局初始化回调
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: this.facebookAppId,
          // appId: FACEBOOK_APP_ID,
          cookie: true,
          xfbml: true, // 允许解析官方按钮标签
          version: FACEBOOK_API_VERSION
        });

        // 订阅登录状态改变
        // window.FB.Event.subscribe('auth.statusChange', (response) => {
        //   if (response.status === 'connected') {
        //     const accessToken = response.authResponse.accessToken;
        //     this.registerOrLoginWithThirdParty(accessToken, 2);
        //   }
        // });
      };

      // 2. 检查页面上是否已经存在这个标签（解决二次执行导致卡死的问题）
      if (document.getElementById('facebook-jssdk')) {
        // 如果 SDK 已经加载完了，直接通知它重新解析一遍页面上的 <div class="fb-login-button">
        if (window.FB && window.FB.XFBML) {
          window.FB.XFBML.parse();
        }
        return; // 直接结束，不再往下走注入逻辑
      }
      const js = document.createElement('script');
      js.id = 'facebook-jssdk';
      js.src = "https://connect.facebook.net/zh_HK/sdk.js";
      document.head.appendChild(js);
    },

    handleFacebookClick() {
      // 埋点：Facebook 点击
      dataLayer.push({
        event: 'userClick',
        source: 'LIP',
        target: 'Facebook',
        user: {
          language: `${window._language}`,
          id: '',
        },
      });

      if (this.isPcLogin) {
        if (window.FB) {
          // 1. 弹出小窗
          window.FB.login((response) => {
            this.$toast.clear();

            // ✨【就是这里！】当用户在小窗点击“Continue as Min”成功后，代码会执行到这里
            if (response.status === 'connected') {
              const accessToken = response.authResponse.accessToken;
              
              // 2. 直接调用后端核心接口，不需要经过 checkFacebookRedirectCallback 
              this.registerOrLoginWithThirdParty(accessToken, 2);
            } else {
              console.warn('用户取消了 Facebook 授权或关闭了弹窗');
            }
          }, { scope: 'public_profile,email' });

        } else {
          this.loginWithFacebookRedirect();
        }
      } else {
        this.loginWithFacebookRedirect();
      }
    },
    handleFacebookLogin() {
      // 埋点：Facebook 自定义按钮点击
      dataLayer.push({
        event: 'userClick',
        source: 'LIP',
        target: 'Facebook',
        user: {
          language: `${window._language}`,
          id: '',
        },
      });

      if (!this.isPcLogin) {
        // 移动端：直接走重定向，避免弹窗被浏览器拦截
        this.loginWithFacebookRedirect();
      } else {
        // PC 端：如果由于某种原因没有渲染官方按钮，点击自定义按钮可以手动触发 SDK 弹窗
        if (window.FB) {
          window.FB.login((response) => {
            if (response.status === 'connected') {
              this.registerOrLoginWithThirdParty(response.authResponse.accessToken, 2);
            }
          }, { scope: 'public_profile,email' });
        }
      }
    },

    // ===== 3. 移动端：重定向跳转逻辑 =====
    loginWithFacebookRedirect() {
      const state = this.generateRandomString();
      sessionStorage.setItem('facebook_oauth_state', state);

      const redirectUri = this.getRedirectUri(); // 你的登录页：https://.../my/login
      const params = new URLSearchParams({
        client_id: this.facebookAppId,
        // client_id: FACEBOOK_APP_ID,
        redirect_uri: redirectUri,
        response_type: 'token', // 隐式授权流，直接返回 token
        scope: 'email,public_profile',
        state: state,
      });

      this.$toast.loading({ message: '', forbidClick: true });
      window.location.href = `https://www.facebook.com/${FACEBOOK_API_VERSION}/dialog/oauth?${params.toString()}`;
    },
    async checkGoogleRedirectCallback() {
      console.log("--- 检测 Google 回调 ---");
      // Google 返回的参数也在 # 后面（例如：#id_token=xxx&state=xxx）
      const hash = window.location.hash;
      const savedState = sessionStorage.getItem('oauth_state');
      if (!hash || !hash.includes('id_token') || !savedState) { return; }

      try {
        // this.isThirdPartyLogging = true;
        this.loginToast = this.$toast.loading({
          message:'',
          forbidClick: true, // 锁死背景防止乱点
          duration: 0,       // 设为 0 永不自动消失
        });
        // 1. 解析 Hash 参数
        const hashParams = new URLSearchParams(hash.substring(1));
        const idToken = hashParams.get('id_token');
        const state = hashParams.get('state');
        // 2. 校验 state 安全性，防止 CSRF 攻击（savedState 已在方法开头读取）
        if (!state || state !== savedState) {
          this.isThirdPartyLogging = false;
          //【关闭 Loading 1】：校验失败，手动关闭
          if (this.loginToast) {this.loginToast.clear();}
          return;
        }
        // 校验成功后及时清除
        sessionStorage.removeItem('oauth_state');
        sessionStorage.removeItem('oauth_nonce'); // 如果存了 nonce 一并清除

        if (idToken) {
          
          // 保存本地状态（按需）
          this.setSocialLoginToken('google', idToken);

          // 3. 调用后端核心接口传递给服务器，注意：Google 的 thirdType 传 1
          await this.registerOrLoginWithThirdParty(idToken, 1);
        }
      } catch (error) {
        this.isThirdPartyLogging = false;
        if (this.loginToast) {this.loginToast.clear();}
      } finally {
        console.log("google清理了hash", window.location.hash)
        // 清理掉 URL 中的 hash 碎片，保持地址栏干净
        window.location.hash = '';
      }
    },
    // ===== 检查并处理 Facebook 回调的 Token =====
    async checkFacebookRedirectCallback() {
      console.log("--- 检测 Facebook 回调 ---");
      // Facebook 的隐式模式返回的参数在 # 后面（例如：#access_token=xxx&state=xxx）
      const hash = window.location.hash;
      if (!hash || !hash.includes('access_token')) {return;}

      try {
        // this.isThirdPartyLogging = true;
        this.loginToast = this.$toast.loading({
          message: this.lang.logining,
          forbidClick: true, // 锁死背景防止乱点
          duration: 0,       // 设为 0 永不自动消失
        });
        // 1. 解析 Hash 参数
        const hashParams = new URLSearchParams(hash.substring(1));
        const accessToken = hashParams.get('access_token');
        const state = hashParams.get('state');
        // 2. 校验 state 安全性，防止 CSRF 攻击
        const savedState = sessionStorage.getItem('facebook_oauth_state');
        if (!state || state !== savedState) {
          this.isThirdPartyLogging = false;
          if (this.loginToast) {this.loginToast.clear();}
          return;
        }
        // 校验成功后及时清除
        sessionStorage.removeItem('facebook_oauth_state');

        if (accessToken) {

          // 保存本地状态防止一键提示干扰（按需）
          this.setSocialLoginToken('facebook', accessToken);

          // 3. 调用后端核心接口传递给服务器，注意：Facebook 的 thirdType 传 2
          await this.registerOrLoginWithThirdParty(accessToken, 2);
        }
      } catch (error) {
        this.isThirdPartyLogging = false;
        if (this.loginToast) {this.loginToast.clear();}
      } finally {
        console.log("facebook清理了hash", window.location.hash)

        // 清理掉 URL 中的 hash 碎片，保持地址栏干净
        window.location.hash = '';
      }
    },

    initAppleSdk() {
      // 如果是 WAP 重定向模式，纯前端拼接 URL 即可，无需加载 SDK 脚本
      if (!this.isPcLogin) {return;}

      // 已初始化则跳过
      if (this.isAppleInitialized) {return;}

      // 清理上次加载失败的残留 script 标签，允许重试
      const existing = document.getElementById('apple-auth-script');
      if (existing) {existing.remove();}

      const redirectUri = this.getRedirectUri();

      const script = document.createElement('script');
      script.id = 'apple-auth-script';
      script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
      script.onload = () => {
        try {
          if (window.AppleID) {
            window.AppleID.auth.init({
              clientId: this.appleClientId,
              redirectURI: redirectUri,
              state: this.generateRandomString(),
              usePopup: true,
            });
            this.isAppleInitialized = true;
            console.log('[Apple SDK] 初始化成功');
          }
        } catch (e) {
          console.error('[Apple SDK] init 异常:', e);
        }
      };
      script.onerror = () => {
        console.error('[Apple SDK] 脚本加载失败');
        // 移除失败的 script 标签，以便下次重试
        const el = document.getElementById('apple-auth-script');
        if (el) {el.remove();}
      };
      document.head.appendChild(script);
    },
    handleAppleSignIn() {
      // 1. 埋点
      if (window.dataLayer) {
        dataLayer.push({
          event: 'userClick',
          source: 'LIP',
          target: 'Apple',
          user: {
            language: `${window._language}`,
            id: '',
          },
        });
      }

      // 2. PC 端使用 SDK 弹窗（如果 PC 端仍想保留 SDK 弹窗）
      if (this.isPcLogin) {
        if (!this.isAppleInitialized) {
          // 尝试重新加载 SDK
          this.initAppleSdk();
          this.$toast('Apple 登录组件加载中，请稍后再试');
          return;
        }
        window.AppleID.auth.signIn().then(async (data) => {
          const idToken = data.authorization.id_token;
          this.setSocialLoginToken('apple', idToken);
          await this.registerOrLoginWithThirdParty(idToken, 3);
        }).catch((error) => {
          console.error('Apple 登录失败或取消:', error);
        });
        return;
      }

      // 3. WAP 端：纯前端 Hash 重定向模式
      this.$toast.loading({ message: '', forbidClick: true });

      // 生成防 CSRF 攻击的 state
      const state = this.generateRandomString();
      sessionStorage.setItem('apple_oauth_state', state);
      const redirectUri = this.getRedirectUri();
      // 构造 Apple 授权链接（注意：完全移除 scope，并指定 response_mode=fragment）
      const params = new URLSearchParams({
        client_id: this.appleClientId,
        redirect_uri: redirectUri, // 填当前前端页面地址
        response_type: 'code id_token',
        response_mode: 'fragment', // 👈 告知 Apple 将凭证带在 #hash 中
        state: state,
      });

      // 跳转至 Apple 官方授权页
      window.location.href = `https://appleid.apple.com/auth/authorize?${params.toString()}`;
    },

    async checkAppleRedirectCallback() {
      console.log("--- 检测 Apple 回调 ---");
      const hash = window.location.hash;
      const savedState = sessionStorage.getItem('apple_oauth_state');

      // 必须确保同时存在 Apple 保存的 state，才认定为 Apple 回调
      if (!hash || !hash.includes('id_token') || !savedState) { 
        return; 
      }

      let isAppleCallback = false;

      try {
        this.loginToast = this.$toast.loading({
          message: this.lang.logining ,
          forbidClick: true,
          duration: 0,
        });
        const hashParams = new URLSearchParams(hash.substring(1));
        const idToken = hashParams.get('id_token');
        const state = hashParams.get('state');

        if (!state || state !== savedState) {
          this.isThirdPartyLogging = false;
          if (this.loginToast) { 
            this.loginToast.clear(); 
          }
          return;
        }

        isAppleCallback = true;
        sessionStorage.removeItem('apple_oauth_state');

        if (idToken) {
          this.setSocialLoginToken('apple', idToken);
          await this.registerOrLoginWithThirdParty(idToken, 3);
        }
      } catch (error) {
        this.isThirdPartyLogging = false;
        if (this.loginToast) {this.loginToast.clear();}
      } finally {
        // 只有确认是 Apple 回调才清理
        if (isAppleCallback) {
          console.log("apple清理了hash", window.location.hash);
          window.location.hash = '';
        }
      }
    },

    // ===== 初始化 Google One Tap =====
    initGoogleOneTap() {
      // 如果已经初始化过，跳过
      if (this.isGoogleInitialized) {return;}
      const path = window.location.pathname.toLowerCase();
      let hlParam = 'zh-HK'; // 默认
      if (path.includes('/en-us/')) {
          hlParam = 'en';
      } else if (path.includes('/zh-hk/')) {
          hlParam = 'zh-HK';
      } else if (path.includes('/zh-cn/')) {
          hlParam = 'zh-CN';
      }
      const sdkUrl = `https://accounts.google.com/gsi/client?hl=${hlParam}`;
      // 加载 Google 登录 SDK
      const script = document.createElement('script');
      script.src = sdkUrl;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.renderGoogleButton(true);
      };
      document.head.appendChild(script);
    },
    cleanupGoogleElements() {
      try {
        // 1. 扫描并移除 Google SDK 强行注入在 body 里的 iframe 容器
        // Google 的容器通常带有 credential_picker_container 等类名或 ID
        const googleContainers = document.querySelectorAll(
          '[id^="CredentialPickerSandboxedFrame"], .credential_picker_container, [src*="accounts.google.com"]'
        );
        
        googleContainers.forEach(el => {
          if (el && el.parentNode) {
            el.parentNode.removeChild(el);
            console.log("🧹 成功移除 Google 遗留元素:", el);
          }
        });

        // 2. 告诉 Google SDK 停止其底层的渲染监听（如果官方库存在的话）
        if (window.google && window.google.accounts && window.google.accounts.id) {
          window.google.accounts.id.cancel(); // 取消当前活跃的 Google 登录会话提示
        }
      } catch (error) {
        console.error("清除 Google 元素失败:", error);
      }
    },
    // // ===== 渲染 Google 登录按钮（One Tap + 标准按钮） =====
    renderGoogleButton(isRetry = false) {
      if (!window.google || !window.google.accounts || !window.google.accounts.id) {
        console.warn('Google Identity Services 未加载');
        return;
      }
        // 1. 解析当前路径获取语言
        const path = window.location.pathname.toLowerCase();
        let currentLocale = 'zh_HK'; // 默认简体中文

        if (path.includes('/en-us/')) {
            currentLocale = 'en';
        } else if (path.includes('/zh-hk/')) {
            currentLocale = 'zh_HK'; // 或者用 'zh_TW'
        } else if (path.includes('/zh-cn/')) {
            currentLocale = 'zh_CN';
        }
      // 初始化
      window.google.accounts.id.initialize({
        client_id: this.googleClientId,
        // client_id:GOOGLE_CLIENT_ID,
        callback: this.handleGoogleCredentialResponse,
        auto_select: false,
        cancel_on_tap_outside: true,
        context: 'signin',
        // 移动端适配
        ux_mode: 'popup',
        // 登录提示文案
        itp_support: true,
      });
      // 方式一：渲染标准按钮（在 .g_id_signin 容器中）
      const signInDiv = this.$refs.googleSignIn;
      if (signInDiv) {
        window.google.accounts.id.renderButton(signInDiv, {
          type: 'standard',
          theme: 'outline',
          size: 'large',
          text: 'signin_with',
          shape: 'rectangular',
          logo_alignment: 'left',
          width: 400,
          locale: currentLocale,
          itp_support: false,
          click_listener: () => {
            // 执行埋点
            dataLayer.push({
              event: 'userClick', // 建议将点击事件与授权成功事件(social-login)区分开
              source: 'LIP',
              target: 'Google',
              user: {
                language: `${window._language}`,
                id: '',
              },
            });
          }
        });
      }

      // 方式二：自动弹出一键登录提示（One Tap）
      // 只有在用户未登录时才自动弹出
      if (!isRetry && !this.getSocialLoginToken('google')) {
        // 延迟 1 秒弹出，避免遮挡页面
        setTimeout(() => {
          window.google.accounts.id.prompt((notification) => {
            if (notification.isNotDisplayed()) {
              console.log('One Tap 未显示原因:', notification.getNotDisplayedReason());
            } else if (notification.isSkippedMoment()) {
              console.log('One Tap 被跳过');
            }
          });
        }, 1000);
      }

      this.isGoogleInitialized = true;
    },

    // ===== Google 登录成功回调（One Tap 和标准按钮共用） =====
    async handleGoogleCredentialResponse(response) {
      const idToken = response.credential;

      // 保存登录状态（用于防重复弹出）
      this.setSocialLoginToken('google', idToken);

      // 调用后端接口
      await this.registerOrLoginWithThirdParty(idToken, 1);
    },

    // ===== 重定向方式登录 Google =====
    loginWithRedirect(provider) {
        // 埋点：Google 点击
        dataLayer.push({
          event: 'userClick',
          source: 'LIP',
          target: 'Google',
          user: {
            language: `${window._language}`,
            id: '',
          },
        });

        // 生成 state 和 nonce 防攻击
        const state = this.generateRandomString();
        const nonce = this.generateRandomString();
        sessionStorage.setItem('oauth_state', state);
        sessionStorage.setItem('oauth_nonce', nonce);

        const redirectUri =  this.getRedirectUri();
        const params = new URLSearchParams({
          client_id: this.googleClientId,
          // client_id:GOOGLE_CLIENT_ID,

          redirect_uri: redirectUri,
          response_type: 'id_token',
          scope: 'openid profile email',
          state: state,
          nonce: nonce,
        });

        // 跳转到 Google 授权页面
        window.location.href =
          `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
    },
    getRedirectUri() {
      const origin = window.location.origin;
      const language = window._language === 'zh-hk' ? '' : `${window._language}/`;
      return `${origin}/my/${language}login`;
    },
    // ===== Facebook 登录（占位） =====
    loginWithFacebook() {
      // TODO: 接入 Facebook SDK
      console .log('loginWithFacebook');
    },

    // ===== 第三方登录核心接口调用 =====
    async registerOrLoginWithThirdParty(idToken, thirdType, userData = null) {
      if(this.isPcLogin){
        this.loginToast = this.$toast.loading({
          message: this.lang.logining,
          forbidClick: true, // 锁死背景防止乱点
          duration: 0,       // 设为 0 永不自动消失
        });
      }
      try {
        // 获取设备码（可从 localStorage 或设备信息获取）
        let platform = document.body.clientWidth > 600 ? 'pc' : 'wap';
        const fromapp = this.$route.query.fromapp;
        if (fromapp) {
          platform = fromapp == 'ios' ? 'app-ios' : 'app-android';
        }
        const deviceCode = this.getDeviceCode();
        const res = await this.axios.post (this.pub.getApi().RegisterOrLoginThirdAccount,{
          "idToken":idToken,
          "thirdType":thirdType,
          "deviceCode":platform,
          ...(userData ? { "user": userData } : {}),
        },
        {
          params: {
            "platform": platform,
          },
        }
      );


        if (res.data.code === 0) {
          // 登录成功
          const resultData = res.data.result || {};

          // 🌟 1. 执行埋点上报逻辑
          this.trackAuthSuccess(thirdType, resultData);

          // 1. 设置 cookies
          const userInfo = JSON.stringify({
            userId: res.data.result.userID,
            nickName: res.data.result.nickName,
          });
          pub.setCookie('ERnJaMWtkM',escape(userInfo),res.data.result.expirationTime); // 写入用户编号
          pub.setCookie('cEVaUDFrZ1kd0RA',res.data.result.token,res.data.result.expirationTime); // 写入token

          // 2. 同步访客收藏数据
          await this.getSyncVisitorCollection();
          // // 保存用户信息到 Vuex / localStorage
          // this.$store.commit('setUserInfo', userInfo);
          // this.$store.commit('setToken', userInfo.token);
          this.pushUrl();
        } else {
          // 处理业务错误码
          this.handleThirdPartyError(res.data.code, res);
        }
      } catch (error) {
        console.error('第三方登录失败:', error);
      }
    },
    // 🌟 登录/注册成功埋点逻辑
    trackAuthSuccess(thirdType, result) {
      try {
        if (!window.dataLayer){ return;}
        // 1. 判断 target 平台
        const targetMap = {
          1: 'Google',
          2: 'Facebook',
          3: 'Apple' // 顺便预留 Apple 标识
        };
        const target = targetMap[thirdType] || 'Google';

        // 2. 根据 isFirstLogin 判断是注册还是登录
        const eventName = result.isFirstLogin ? 'userSignup' : 'userLogin';

        // 3. 语言获取（有全局变量用全局，无全局取当前环境/路由）
        const language = window._language || 'zh-hk';
        // 4. 上报 dataLayer
        dataLayer.push({
          event: eventName,
          source: 'LIP',
          target: target,
          user: {
            language: language,
            id: result.userID || ''
          }
        });
      } catch (e) {
        console.error('登录注册埋点异常:', e);
      }
    },
    // ===== 处理第三方登录错误码 =====
    handleThirdPartyError(code, res) {
      const errorMessages = {
        1339: '偵測到重複的電郵。請先用手提電話登入，登入後即可在會員中心啟用快速登入。',
        13001: '參數不合法，請稍後再試',
        1345: '註冊失敗，請稍後再試',
        12003: '操作過於頻繁，請稍後再試',
      };
      if(code == 1339){
        const classname =  this.isPc ? 'custom-toast-style':'customwap-toast-style'
        this.$toast({
          message: window._language == 'en-us' && !this.isPc ? this.lang.email_loginwap : this.lang.email_login,
          type: 'text',          // 確保是純文本模式，不帶任何圖標
          position: 'middle',    // 居中顯示
          className: classname, // 自定義類名用來修飾樣式
          duration: 6000         // 顯示時間（毫秒）
        });
      }else if(code == 1312){
        if(this.loginToast){
          this.loginToast.clear()
        }
        this.number = 1312;
        this.thirtyError = true
        this.error = this.lang.disabledText.replace('error', res.data.result.disableReasonWithCulture);
        if(this.tabLogin == 1){
          this.$refs.form.openDialog();
        }else{
          this.$refs.forms.openDialog();
        }
      }else{
        const tip = res.data.message || errorMessages[code] || this.lang.failLogin+ '('+code+')';
        this.$toast(tip)
      }
    },

    // ===== 工具方法 =====

    // 生成随机字符串
    generateRandomString() {
      return Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
    },

    // 获取设备码
    getDeviceCode() {
      let deviceCode = localStorage.getItem('device_code');
      if (!deviceCode) {
        // 简单生成一个设备码（生产环境建议使用更可靠的方案）
        deviceCode = 'web_' + this.generateRandomString();
        localStorage.setItem('device_code', deviceCode);
      }
      return deviceCode;
    },

    // 存储社交登录 Token（防止重复弹出 One Tap）
    setSocialLoginToken(provider, token) {
      sessionStorage.setItem(`social_login_${provider}`, token);
    },

    // 检查是否已登录
    getSocialLoginToken(provider) {
      return sessionStorage.getItem(`social_login_${provider}`);
    },

    // //  新增：抽取出来的统一静态保底执行方法
    // executeFallback(id) {
    //   if (id == 'GoogleClientId') {
    //     console.log('谷歌启用本地静态保底 client_id');
    //     this.googleClientId = '121908932267-mn7d1lgqcc5evtl1fure8udvb6u9pemn.apps.googleusercontent.com';
    //     this.initGoogleOneTap();
    //     this.renderGoogleButton();
    //   } else if (id == 'FacebookClientId') {
    //     console.log('脸书启用本地静态保底 appId');
    //     this.facebookAppId = '2192880504836211';
    //     this.initFacebookSdk();
    //   }
    //   this.isConfigLoaded = true;
    // },


    // onTurnstileCallback() {
    //   console.log('Turnstile callback executed.');
    // },
    changeSubStatus() {
      this.model.subscribeEmailStatus = !this.model.subscribeEmailStatus;
    },
    test() {
      // this.$router.push('/');
    },
    /*——————公共方法——————*/
    /*登入/教学*/
    goSchool() {
      // if (document.body.clientWidth > 600) {
      //   window.location.href = 'https://promotion.house730.com/newuser_pc/';
      // } else {
      //   window.location.href = 'https://promotion.house730.com/newuser_app/';
      // }
      this.$router.push('/school');
    },
    /* 清空输入框*/
    delModel(type) {
      this.model[type] = '';
      if (type == 'telephone') {
        this.model.subscribeEmail = '';
        this.editDisable = false;
        this.subscribeTo = true;
        this.haveRegister = false;
        this.model.subscribeEmailStatus = true;
      }
    },
    delLoginList(type) {
      this.loginList[type] = '';
    },
    /* 重置表单 */
    resetForm() {
      this.model = {
        telephone: '',
        code: '',
        check: '852',
        agree: '',
        subscribeEmail: '',
        subscribeEmailStatus: true,
      };
      //登入数据
      this.loginList = {
        telephone: '',
        password: '',
        check: '852',
        email: '',
      };
      this.verifyCode = '';
      this.verifyToken = '';
      this.eyeType = 'password';
      this.eyeSvg = '#icon-yincangmima';
      this.error = '';
      this.imgValidatorOpen = false;
      this.subscribeTo = true
    },
    /* 抬头切换 */
    cutoverTab() {
      this.resetForm();
    },
    /* 验证码倒数回调 */
    endBackword(type) {
      console.log(type);
      // this.switchCode = type;
      this.error = type;
    },
    /* 前往忘記密碼 */
    goForget() {
      this.$router.push('/forget');
    },
    /*返回登入前页面方法*/
    pushUrl() {
      const curLang = window._language === 'en-us' ? 'en-us/' : window._language === 'zh-hk' ? '' : 'zh-cn/';
      /**添加手册登录判断 */
      const isFirstLog = this.isfirstlogin ? '?isfirstlogin=true' : '';
      if (this.isfirstlogin) {this.pub.setCookie('isfirstlogin', '1');}
      let referrer = this.$route.query.referer || this.$route.query.referrer || '';
      referrer = referrer.replace('isfirstlogin', 'fst');
      referrer && referrer.indexOf('account') > -1 ? (referrer = null) : '';
      if (!referrer) {
        document.body.clientWidth > 700 ? (location.href = this.pub.config.pcPassport + curLang + isFirstLog) : (location.href = this.helpConfig +"/my/"+ curLang + isFirstLog) ;
        // document.body.clientWidth > 700 ? (location.href = this.pub.config.pcPassport + curLang + isFirstLog) : this.$router.push('/' + isFirstLog);
      } else {
        if (document.referrer && referrer && document.referrer.indexOf('/login') == -1) {
          // document.body.clientWidth > 700 ? (location.href = referrer + isFirstLog) : history.back(-1)
          // liu 0824 修改
          if (document.body.clientWidth > 700) {
            location.href = referrer + isFirstLog;
          } else {
            location.href = referrer + isFirstLog;
            // // history.back(-1)

            /**
             * 老版本浏览历史页单独处理跳转(原因:未知)
             * */
            // 樓盤收藏走的
            // if (referrer.indexOf('/history') == -1) {
            //   location.href = referrer + isFirstLog;
            // } else {
            //   location.href = `/my` + curLang + referrer + isFirstLog;
            // }
          }
        } else if (this.$route.query.url) {
          location.href = referrer + `&url=${this.$route.query.url}&isfirstlogin=true`;
        } else {
          /**正常跳转 */
          location.href = referrer + isFirstLog;
        }
      }
    },
    /*——————快捷驗證登入——————*/

    /* 点击验证码按钮 */
    sendCode(error) {
      this.error = error;
    },

    /* 点击登入 */
    async fastLogin() {
      // let { telephone, agree, code } = this.model;
      let { telephone, agree, code, subscribeEmail, subscribeEmailStatus } = this.model;
      if (!this.fastLightBtn) {return;}
      if (!agree) {
        this.agreeShow = true;
        return;
      }
      // console.log(111111111);
      // if (!this.turnstileVerified) {
      //   this.error = "请先完成人机验证";
      //   return;
      // }

      this.axios
        .post(pub.getApi().LoginByCaptcha, {
          type: 'Captcha',
          phoneCode: '852',
          account: telephone,
          smsCaptcha: code,
          subscribeEmail: subscribeEmail,
          subscribeEmailStatus: subscribeEmailStatus,
          // turnstileToken: this.turnstileToken
        })
        .then(async (res) => {
          console.log('快捷登入', res);
          if (res.data.code == 0) {
            this.number = 0;
            // console.log("res.data.result.userID",res.data.result.userID)
            console.log('登入成功！');
            /**记录是否是第一次登录 */
            this.isfirstlogin = res.data.result.isFirstLogin;
            let referrer = this.$route.query.referer || this.$route.query.referrer || '';
            let resregister = this.$route.query.from == 'resregister' ? true : false;
            let reslogin = this.$route.query.from == 'reslogin' ? true : false;
            if (this.isfirstlogin) {
              dataLayer.push({
                event: 'userSignup',
                source: resregister || reslogin ? 'favorite_limit' : 'LIP',
                target: '',
                user: {
                  language: `${window._language}`, // ie 'zh-hk'
                  id: `${res.data.result.userID}`, // ie '41121'
                },
              });
            } else {
              dataLayer.push({
                event: 'userLogin',
                source: resregister || reslogin ? 'favorite_limit' : 'LIP',
                target: '',
                user: {
                  language: `${window._language}`, // ie 'zh-hk'
                  id: `${res.data.result.userID}`, // ie '41121'
                },
              });
            }
            try {
              // 1. 设置 cookies
              const userInfo = JSON.stringify({
                userId: res.data.result.userID,
                nickName: res.data.result.nickName,
              });
              pub.setCookie('ERnJaMWtkM',escape(userInfo),res.data.result.expirationTime); // 写入用户编号
              pub.setCookie('cEVaUDFrZ1kd0RA',res.data.result.token,res.data.result.expirationTime); // 写入token

              // 2. 同步访客收藏数据
              await this.getSyncVisitorCollection();

              // 3. 完成后进行跳转
              sessionStorage.setItem('hsasLogin', document.referrer);
              this.pushUrl();
            } catch (error) {
              console.error('Error during post-login process:', error);
              // 可以添加错误处理逻辑
            }
            // if (this.backUrl != '/') {
            //   window.location.href = this.backUrl;
            // } else {
            //   this.$router.push('/');
            // }
          } else if (res.data.code == 1312) {
            this.number = 1312;
            this.error = this.lang.disabledText.replace('error', res.data.result.disableReasonWithCulture);
            // 调用子组件中打开弹窗的方法
            this.$refs.forms.openDialog();
          } else {
            this.number = res.data.code;
            this.error = this.lang.SMSErrorLang;
          }
        });
      // console.log('点击登入');
    },
    // 注册 失去焦点获取订阅电邮
    hasSubEmail() {
      if (this.modelTel && !this.error) {
        this.axios
          .get(pub.getApi().GetUserSubscribeEmailByPhone, {
            params: {
              phone: this.modelTel,
            },
          })
          .then((res) => {
            this.haveRegister = false
            if (res.data.code == 0 && res.data.result) {
              this.haveRegister = true;
              if (res.data.result.subscribeEmail) {
                this.model.subscribeEmail = res.data.result.subscribeEmail;
                this.editDisable = true;
              } else {
                this.model.subscribeEmail = '';
                this.editDisable = false;
              }
              if(res.data.result.subscribeEmailStatus) {
                this.subscribeTo = !res.data.result.subscribeEmailStatus;
                this.model.subscribeEmailStatus = true;
              } else {
                this.subscribeTo = !res.data.result.subscribeEmailStatus;
                this.model.subscribeEmailStatus = false;
              }
            } else {
              this.editDisable = false;
              this.model.subscribeEmail = '';
              this.model.subscribeEmailStatus = true;
            }
          });
      } else if (this.modelTel == '') {
        // 针对手动删除电话
        this.model.subscribeEmail = '';
        this.editDisable = false;
        // this.model.subscribeEmailStatus = true;
      }
    },
    /*——————賬號密碼登入——————*/
    /*失去焦点获取密码*/
    hasPassword(type) {
      if ((this.loginListTel || this.loginListEmail) && !this.error) {
        this.axios
          .post(pub.getApi().IsAllowPasswordLogin, {
            type: type,
            phoneCode: type == 'Phone' ? '852' : null,
            account: type == 'Phone' ? this.loginListTel : this.loginListEmail,
          })
          .then((res) => {
            let have = res.data.result;
            if (have || this.tabLogin == 0) {
              this.error = '';
            } else {
              this.error = this.lang.hasPasswordLang;
            }
          });
      }
    },
    /* pc端改版电话、邮箱登入切换方式 */
    checkPcLogin() {
      this.loginType == 'email' ? (this.loginType = 'tel') : (this.loginType = 'email');
      console.log('切换');
    },
    /* 电话、邮箱登入切换方式 */
    checkLogin(type) {
      this.loginType = type;
      this.resetForm();
    },

    /* 账号密码登入按钮 */
    loginBtn() {
      let { telephone, password, check, email } = this.loginList;
      console.log("点击登录",this.loginList)
      console.log("this.loginType",this.loginType)
      console.log("telephone, password, check, 'phone', this.verifyCode, this.verifyToken",telephone, password, check, 'phone', this.verifyCode, this.verifyToken)
      if (this.loginType == 'tel') {
        if (telephone.length == 0 || password.length == 0) {return;}
        // console.log(11111111);
        let telResult = this.pub.telValidator(telephone, check);
        let pdResult = this.pub.passwordValidator(password);
        if (telResult == 1 || telResult == 2) {
          this.error = this.lang.errTelFormLang;
        } else if (pdResult == 1) {
          this.error = this.lang.errPasswordFormLang;
        } else {
          this.error = '';
          this.loginApi(telephone, password, check, 'phone', this.verifyCode, this.verifyToken);
        }
      } else {
        if (email.length == 0 || password.length == 0) {return;}
        // console.log(1111111);
        let emResult = this.pub.emailValidator(email);
        let pdResult = this.pub.passwordValidator(password);
        if (emResult == 1) {
          this.error = this.lang.errEmailFormLang;
        } else if (pdResult == 1) {
          this.error = this.lang.errPasswordFormLang;
        } else {
          this.error = '';
          this.loginApi(email, password, '', 'email', this.verifyCode, this.verifyToken);
        }
      }
    },
    /* 登入接口 */
    async loginApi(account, password, code = '', type = 'phone', verifyCode = '', verifyToken = '') {
      this.axios
        .post(
          this.pub.getApi().LoginByPassword,
          {
            type: type,
            code: code,
            account: account,
            password: password,
          },
          {
            params: {
              'h-recaptchavalue': verifyCode,
              'h-recaptcha': verifyToken,
            },
          }
        )
        .then(async (res) => {
          console.log('登入结果', res);
          if (res.data.code == 0) {
            this.number = res.data.code;
            let referrer = this.$route.query.referer || this.$route.query.referrer || '';
            let resregister = this.$route.query.from == 'resregister' ? true : false;
            let reslogin = this.$route.query.from == 'reslogin' ? true : false;
            dataLayer.push({
              event: 'userLogin',
              source: resregister || reslogin ? 'favorite_limit' : 'LIP',
              target: '',
              user: {
                language: `${window._language}`,
                id: `${res.data.result.userID}`,
              },
            });
            // console.log("mima登入",window.dataLayer)

            // console.log("res.data.result.userID",res.data.result.userID)
            console.log('登入成功！');

            this.isfirstlogin = res.data.result.isFirstLogin;
            this.imgValidatorOpen = false;
            this.resetForm();
            try {
              // 1. 设置 cookies
              const userInfo = JSON.stringify({
                userId: res.data.result.userID,
                nickName: res.data.result.nickName,
              });
              pub.setCookie('ERnJaMWtkM',escape(userInfo),res.data.result.expirationTime); // 写入用户编号
              pub.setCookie('cEVaUDFrZ1kd0RA',res.data.result.token,res.data.result.expirationTime);

              // 2. 同步访客收藏数据
              await this.getSyncVisitorCollection();

              // 3. 完成后进行跳转
              sessionStorage.setItem('hsasLogin', document.referrer);

              if (this.isPc) {
                if (pub.getLang() === 'zh-cn') {
                  location.href = `${pub.config.pcUrl}zh-cn/help/memberlogin/`;
                } else if (pub.getLang() === 'en-us') {
                  location.href = `${pub.config.pcUrl}en-us/help/memberlogin/`;
                } else {
                  location.href = `${pub.config.pcUrl}help/memberlogin/`;
                }
              }
              this.pushUrl();

            } catch (error) {
              console.error('Error during post-login process:', error);
              // 可以添加错误处理逻辑
            }

          } else if (res.data.code == 101) {
            this.number = res.data.code;
            this.loadImg();
            if (this.imgValidatorOpen) {
              this.error = this.lang.SMSErrorLang;
            }
            this.imgValidatorOpen = true;
          } else if (res.data.code == 1310) {
            this.number = res.data.code;
            console.log('错误1301');
            this.imgValidatorOpen = false;
            this.verifyCode = '';
            this.error = this.lang.errMaxLang;
          } else if (res.data.code == 1312) {
            console.log('错误1312');
            this.number = 1312;
            this.error = this.lang.disabledText.replace('error', res.data.result.disableReasonWithCulture);
            // 调用子组件中打开弹窗的方法
            this.$refs.form.openDialog();
          } else {
            this.number = res.data.code;
            console.log('错误1300');
            this.error = this.lang.errAllLang;
            if (this.imgValidatorOpen) {
              this.loadImg();
            }
          }
        });
    },
    /* 密码显示隐藏 */
    eyeOpen() {
      this.eyeType == 'password' ? (this.eyeType = 'text') : (this.eyeType = 'password');
      this.eyeSvg == '#icon-yincangmima' ? (this.eyeSvg = '#icon-xianshimima') : (this.eyeSvg = '#icon-yincangmima');
    },
    /* 图片验证码 */
    loadImg() {
      this.axios(pub.getApi().GetRecaptcha).then((res) => {
        console.log('图片', res);
        if (res.data.code === 0) {
          this.verifyImg = 'data:image/png;base64,' + res.data.result.image;
          this.verifyToken = res.data.result.token;
        }
      });
    },
    // loadImgFast() {
    //   this.axios(pub.getApi().GetRecaptcha).then((res) => {
    //     console.log('图片', res);
    //     if (res.data.code === 0) {
    //       this.verifyImg = 'data:image/png;base64,' + res.data.result.image;
    //       this.verifyToken = res.data.result.token;
    //     }
    //   });
    // },
    /* 给cookie修改为180天时效 */
    setCookieTo(name, value, timestamp) {
      var date = new Date(timestamp * 1000);
      date.setTime(date.getTime() + 2 * 60 * 1000);
      var expires = "; expires=" + date.toUTCString();
      document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
    },
    // 合并访客收藏数据
    async getSyncVisitorCollection() {
      const deviceCode = this.pub.getCookie('Y190cmFja2lk');
      if (deviceCode) {
        try {
          const res = await this.axios.post(this.pub.getApi().SyncVisitorCollection, {
            deviceCode: deviceCode
          });
          console.log('访客收藏数据合并成功');
          return res;
        } catch (error) {
          console.error('访客收藏数据合并失败:', error);
          throw error;
        }
      } else {
        console.warn('未找到访客标识，跳过合并收藏');
        return null;
      }
    }
  },
};
</script>
<style lang="scss" scoped>

@import url('../../assets/base.css');
.loading {
  font-size: 22px;
  position: absolute;
  top: 50%;
  left: 50%;
  // transform: translate(-50%, -50%);
  z-index: 9999;
}
.overlay-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%; /* 关键：继承 van-overlay 的 100% 高度实现垂直居中 */
}

.loading-text {
  margin-top: 10px;
  color: #1989fa; /* 配合你转圈圈的蓝色 */
  font-size: 16px;
  font-weight: 500;
}
.tab-content{
  margin:20px 0;
  font-size: 14px;
  color: #333333;
  .line{
    display: inline-block;
    border: 1px solid #DDDDDD;
    vertical-align: middle;
    width: 47%;
    background-color: #DDDDDD;
  }
}
// .googlebox{
//   margin-left: 10px;
//   padding-top: 20px;
//   display: inline-block;

// }
// .facebookbox{
//   margin-left: 25px;
//   padding-top: 20px;
//   display: inline-block;
//   margin-bottom: 20px;
// }
// .custom-google-wrapper {
//   position: relative;
//   width: 44px;  /* 匹配你设计稿的大小 */
//   height: 44px;
//   display: inline-block;
//   cursor: pointer;
// }
// .custom-facebook-wrapper {
//   position: relative;
//   width: 44px;  /* 匹配你设计稿的大小 */
//   height: 44px;
//   display: inline-block;
//   cursor: pointer;
// }

// /* 自己设计的圆形按钮 */
// .design-btn {
//   width: 100%;
//   height: 100%;
//   border-radius: 50%;
//   border: 1px solid #ddd; /* 对应你截图里的灰色虚线外框样式 */
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: #fff;
// }
// .design-btn img {
//   width: 24px;
//   height: 24px;
// }
.googlebox, .facebookbox, .applebox {
  display: inline-block;
  padding-top: 20px;
  vertical-align: middle; /* 确保两个第三方按钮在一条水平线上对齐 */
  margin-left: 25px;
  margin-bottom: 20px;
}

.googlebox {
  margin-left: 0;
}

// .facebookbox {
//   margin-left: 25px;
//   margin-bottom: 20px;
// }

.custom-google-wrapper, .custom-facebook-wrapper, .custom-apple-wrapper {
  position: relative;
  width: 44px;  /* 严格匹配你的设计稿 44x44 */
  height: 44px;
  display: inline-block;
  cursor: pointer;
  user-select: none; /* 防止移动端长按或连点时高亮选中图片 */
  -webkit-tap-highlight-color: transparent; /* 移除暗红/灰色点击蒙层 */
}

/* 🌟 新增：确保按钮内的图片完美等比缩放且居中 */
.design-btn {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.design-btn img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 保证图片在 44px 盒子里保持比例居中容纳 */
  border-radius: 50%;  /* 如果设计稿是圆形图标可以开启，如果是方块可注释掉 */
}

/* 官方按钮：隐形人 */
.hidden-google-btn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  opacity: 0; /* 🌟 核心：透明度设为0，完全隐形但可以被点击 */
  z-index: 10;
  overflow: hidden;
}
/* 强行让谷歌内部的 iframe 撑满容器 */
.hidden-google-btn iframe {
  width: 100% !important;
  height: 100% !important;
  transform: scale(2); /* 放大内部点击区域，确保用户点哪里都能点中 */
}


::v-deep .g_id_signin div, 
::v-deep .g_id_signin [role="button"] {
  // width: 430px !important;
  max-width: 460px !important;
}
::v-deep .g_id_signin {
  width: 400px !important;
  max-width: 400px !important;
  
  /* 🚀 物理拉伸 1.075 倍 (430 / 400) */
  transform: scale(1.075);
  transform-origin: left center; /* 靠左对齐放大 */
}
.login {
  width: 100%;
  height: 100%;
  overflow: auto;
  .cut_pc_btn {
    display: none;
  }

  .mt30 {
    margin-top: 30px;
  }
  .third-party-buttons{
    border:1px solid #dadce0; 
    margin-top: 10px; 
    height: 38px; 
    width: 100%; 
    background-color: #ffffff; 
    border-radius: 4px; 
    padding-top: 5px;
    line-height: 35px;
    cursor: pointer;
  }
  .social-icon{
    width: 20px;
    height: 20px;
    position: absolute;
    left: 11px;
    bottom: 11px;
  }
  .social-text{
    color:#3c4043;
    padding-left: 25px;
    font-weight: 500;
  }
  .social-icon-go{
    bottom: 60px;
  }
  .red_btn {
    cursor: pointer;
    padding: 15px;
    color: #fff;
    font-size: 17px;
    background-color: #f6afb4;
    margin-top: 30px;
  }
  .red_txt{
    color: #e70e1a;
    font-size: 14px;
    margin-top: 34px;
    padding-left: 3px;
  }
  .red_btn_111 {
    cursor: pointer;
    padding: 15px;
    color: #fff;
    font-size: 17px;
    background-color: #f6afb4;
    margin-top: 115px;
  }
  .red_bottom{
    margin-top:130px;
  }
  .red_btn_30 {
    cursor: pointer;
    padding: 15px;
    color: #fff;
    font-size: 17px;
    background-color: #f6afb4;
    margin-top: 30px;
  }
  .write_btn {
    cursor: pointer;

    padding: 15px;
    color: #b4b4b4;
  }
  .school_btn {
    cursor: pointer;

    padding: 15px;
    color: #0076ff;
  }

  .icon_eye {
    cursor: pointer;
    font-size: 30px;
    color: #b9b9b9;
  }
  .verifyImg {
    cursor: pointer;
    height: 30px;
    max-width: 120px;
  }
  .cut_btn {
    text-align: right;
    // width: 80px;
  }
  .agree_case {
    .agree_content {
      padding: 40px 20px 20px;
      line-height: 24px;
      font-size: 16px;
      color: #333;
    }
  }
  .login_case{
    width: 35%;
      .login_content {
        padding: 20px 0 20px 0; 
        line-height: 24px;
        font-size: 16px;
        color: #333;
        width: 90px;
      }
      .loading{
        top: 35%;
        left: 67%
      }
  }
  .login_wap {
    font-size: 14px;
    padding: 0px 15px;
    padding-top: 44px;
    .login_wap_img {
      width: 75px;
      height: 77px;
      margin-bottom: 24px;
    }
    .login_pc_title {
      display: none;
    }
    .login_wap_form {
      margin: 30px 0 0;
    }
    .login_wap_form_item {
      border-bottom: 1px solid #eee;
    }
    .login_wap_form_item:hover {
      border-bottom: 1px solid red;
    }
    .login_wap_agree {
      margin: 16px 0 10px 0;
    }
    .conCheckboxList {
      text-align: left;
      position: relative;
      min-height: 36px;
      max-height: 54px;
    }
    .sub_tit {
      cursor: pointer;
      width: 91%;
      // margin-left: 27px;
      display: inline-block;
      line-height: 18px;
      position: absolute;
      top: -4px;
    }
    .login_pc_remember {
      display: none;
    }
    .login_wap_forget_case {
      .login_wap_forget {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .login_pc_forget {
      display: none;
    }
    .agree {
      .agree_info {
        // margin: 0 5px;
      }
      a {
        color: #0076ff;
      }
    }
  }
}
@media screen and (min-width: 601px) {
  .login {
    background-image: url('//static.house730.com/m/images/pcbg.jpg');
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-size: cover;
    .agree_case {
      width: 350px;
      .agree_content {
        padding: 40px 20px 20px;
      }
    }
    .login_case{
      width: 110px;
        .login_content {
          padding: 20px 0 20px 0;
        }
        .loading{
          top: 35%;
          left: 66%;
        }
    }
    .guide {
      border: 0;
    }
    .login_wap {
      .login_wap_img {
        display: none;
      }
      .login_wap_forget_case {
        display: none;
      }
    }
    .login_pc {
      font-size: 16px;
      background-color: #fff;
      width: 500px;
      box-sizing: border-box;
      padding: 35px;
      .login_pc_title {
        display: block;
        padding-bottom: 20px;
      }
      .login_pc_form {
        margin: 40px 0 60px;
      }
      /deep/.info_err {
        // bottom: -40px;
        bottom: -55px;
        font-size: 16px;
      }
      .cut_pc_btn {
        display: block;
        padding: 5px 10px;
        position: absolute;
        top: 60px;
        right: 0px;
        font-size: 14px;
        background-color: #0076ff;
        color: #fff;
        border-radius: 5px 5px 0 0;
      }
      .cut_btn {
        display: none;
      }
      .login_pc_form_item {
        background-color: #f6f6f6;
        // border: none;
        border: 1px solid rgba(255, 255, 255, 1);
        margin-bottom: 25px;
      }
      .login_pc_form_item:hover {
        border: 1px solid #e70e1a;
      }
      .login_pc_remember {
        cursor: pointer;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-bottom: 2px;
      }
      .login_pc_forget {
        display: block;
      }
    }
  }
}
// .cf-turnstile-container {
//   position: fixed;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   z-index: 1000;
//   background: white;
//   padding: 20px;
//   border-radius: 8px;
//   box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
// }
</style>
